// src/services/contactService.js

const BASE_URL = "https://user.globtel.biz/api/";
const TIMEOUT_MS = 10000; // 10s

export function buildContactUrl(params) {
  const url = new URL("partner/contact", BASE_URL);
  url.searchParams.set("name", params.name || "");
  url.searchParams.set("email", params.email || "");
  url.searchParams.set("subject", params.subject || "");
  url.searchParams.set("message", params.message || "");
  return url.toString();
}

export async function sendContact(params) {
  const url = buildContactUrl(params);

  // Timeout via AbortController / AbortSignal
  const controller = new AbortController();
  const t = setTimeout(() => controller.abort(), TIMEOUT_MS);

  try {
    const res = await fetch(url, {
      method: "GET",
      headers: { accept: "application/json" },
      signal: controller.signal,
    });
    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Request failed: ${res.status} ${text}`);
    }
    const data = await res.json().catch(() => ({}));
    return data; // expected: { detail: "Your email has been sent successfully." }
  } finally {
    clearTimeout(t);
  }
}
